export enum CaseExternalService {
  DENTAL_MONITORING = "DENTAL_MONITORING",
}
